import React from 'react';
import _ from 'lodash';
import Promise from 'bluebird';
import FormField from 'shared/components/ui/formField';
import Button from 'shared/components/ui/button';
import FacebookBtn from 'shared/components/facebookBtn';
import View from 'components/ui/view';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errors: {},
      loading: false,
      showForgotPassword: false
    };
    this.model = {
      email: props.email || '',
      password: ''
    };
  }

  validateEmail(email) {
    if (!email) return "Email can't be blank";
  }

  validatePassword(password) {
    if (!password) return "Password can't be blank";
  }

  validateFields() {
    const { email, password } = this.model;

    let errors = {};
    errors.email = this.validateEmail(email) || null;
    errors.password = this.validatePassword(password) || null;

    this.setState({ errors });

    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true, error: null });
    return this.validateFields()
      .then(() => this.props.onSubmit(this.model))
      .then(() => this.props.onSuccess && this.props.onSuccess())
      .catch(({ message }) => {
        this.setState({ loading: false, error: message });
      });
  }

  render() {
    return (
      <div className="text-left">
        <form onSubmit={e => this.handleSubmit(e)}>
          {this.state.error && (
            <div className="warning">{this.state.error}</div>
          )}

          <div className="row">
            <div className="col-xs-12">
              <FormField
                id="user-email"
                name="email"
                labelText="Email"
                inputType="email"
                initialValue={this.model.email}
                onChange={email => (this.model = { ...this.model, email })}
                validate={email => this.validateEmail(email)}
                error={this.state.errors.email}
              />
            </div>

            <div className="col-xs-12">
              <FormField
                id="user-password"
                name="password"
                labelText="Password"
                inputType="password"
                onChange={password =>
                  (this.model = { ...this.model, password })}
                validate={password => this.validatePassword(password)}
                error={this.state.errors.password}
              />
            </div>
          </div>

          <div className="row end-xs">
            <div className="col-xs-12">
              <View margin="sm">
                <small>
                  <a
                    className="link-text"
                    onClick={
                      this.props.showForgotPassword
                        ? () => this.props.showForgotPassword()
                        : null
                    }
                    href={
                      this.props.showForgotPassword ? null : '/forgot-password'
                    }
                  >
                    Forgot password?
                  </a>
                </small>
              </View>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Button
                type="submit"
                className="btn-primary green btn--full-width"
                disabled={this.state.loading}
                loading={this.state.loading}
              >
                Sign In
              </Button>
            </div>
          </div>
        </form>

        <View margin="sm">
          <div className="divider-group">
            <div className="divider-group__text">OR</div>
            <div className="divider-group__divider" />
          </div>
        </View>

        <View margin="sm">
          <FacebookBtn
            className="btn--full-width"
            onLogin={() => {
              this.props.onSuccess && this.props.onSuccess();
            }}
            onComplete={() => {
              this.props.onSuccess && this.props.onSuccess();
            }}
            onError={({ message }) => {
              this.setState({ error: message });
            }}
          />
        </View>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./shared/components/login/login.js